import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of as observableOf } from 'rxjs';
import { UserSessionService } from '../../services/user-session/user-session.service';
import { AppRoutes } from '../../Constants/app-routes';
import { AuthService } from '../../../login/auth/auth.service';
import { AppConfigService } from '../../services/app-config/app-config.service';
import { ChatbotResetLayoutService } from '../../services/sabis-chatbot/chatbot-reset-layout.service';


@Injectable({
  providedIn: 'root'
})
export class ActiveSessionGuard  {
  constructor(
    private _userSessionService: UserSessionService,
    private authService: AuthService,
    private _router: Router,
    private appConfig: AppConfigService,
    private _chatbotResetStyles: ChatbotResetLayoutService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    if (!this._userSessionService.isSessionActive()) {
      this._chatbotResetStyles.resetChatbotStyles();
      if (this.appConfig.config.useSDPIdentityServerAuthentication) {
        return this.authService.authenticateWithCMS();
      } else {
        this._router.navigateByUrl(AppRoutes.login);
        return observableOf(false);
      }
    }
    else {
      return observableOf(true);
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
